import React, { useState } from 'react';
// @ts-ignore
import styles from './DiscourseControls.module.scss';
import AddButton from '../../../../Components/Button/AddButton';
import MedicalReportDetailModal from '../../../../Components/MedicalReport/MedicalReportDetailModal';
import ElectronicPrescriptionModal from '../../../Prescription/Components/ElectronicPrescriptionModal';
import { useDiscourseContext } from '../../Services/DiscourseContext';
import InsuranceReportCreateModal from '../../../Insurance/Component/InsuranceReportCreate/InsuranceReportCreateModal';
import { useAclContext } from '../../../Acl/Components/AclContextProvider';

interface Props {
	allowElectronicPrescription?: boolean;
	allowMedicalReport?: boolean;
	patientId: string;
	virtualPatientId: string;
	caseId?: string;
	workplaceId: string;
}

const DiscourseControls: React.FC<Props> = ({
	allowElectronicPrescription = true,
	allowMedicalReport = true,
	virtualPatientId,
	patientId,
	caseId,
	workplaceId,
}) => {
	const { handleRefreshAttachments } = useDiscourseContext();
	const { isAllowed } = useAclContext();

	const [
		isElectronicPrescriptionCreateOpen,
		setIsElectronicPrescriptionCreateOpen,
	] = useState(false);
	const [isMedicalReportCreateOpen, setIsMedicalReportCreateOpen] =
		useState(false);
	const [isInsuranceReportCreateOpen, setIsInsuranceReportCreateOpen] =
		useState(false);

	return (
		<>
			<div className={styles.wrapper}>
				{allowElectronicPrescription && (
					<AddButton
						title='base.issueEprescription'
						onClick={() => setIsElectronicPrescriptionCreateOpen(true)}
					/>
				)}
				{allowMedicalReport && (
					<AddButton
						title='base.shared.createMedicalReport'
						onClick={() => setIsMedicalReportCreateOpen(true)}
					/>
				)}
				{isAllowed('insuranceReport') && (
					<AddButton
						title='base.insuranceReport'
						onClick={() => setIsInsuranceReportCreateOpen(true)}
					/>
				)}
			</div>
			{isMedicalReportCreateOpen && (
				<MedicalReportDetailModal
					opened
					onClose={() => setIsMedicalReportCreateOpen(false)}
					onMedicalReportCreate={handleRefreshAttachments}
					workplaceId={workplaceId}
					patientId={virtualPatientId}
					caseId={caseId}
					attachToDiscourse
					createDekurz={false}
				/>
			)}
			{isElectronicPrescriptionCreateOpen && (
				<ElectronicPrescriptionModal
					opened
					onClose={() => setIsElectronicPrescriptionCreateOpen(false)}
					onCreate={handleRefreshAttachments}
					patientId={patientId}
					attachToDiscourse
					createDekurz={false}
				/>
			)}
			{isInsuranceReportCreateOpen && (
				<InsuranceReportCreateModal
					patientId={virtualPatientId}
					isOpen
					onClose={() => setIsInsuranceReportCreateOpen(false)}
					onCreate={() => setIsInsuranceReportCreateOpen(false)}
					attachToDiscourse
				/>
			)}
		</>
	);
};

export default DiscourseControls;
